import { render } from "./PageLoader.vue?vue&type=template&id=7183ec7a&scoped=true"
import script from "./PageLoader.vue?vue&type=script&lang=js"
export * from "./PageLoader.vue?vue&type=script&lang=js"

import "./PageLoader.vue?vue&type=style&index=0&id=7183ec7a&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7183ec7a"]])

export default __exports__